import { useState } from 'react';
import { AppProps } from '../../App';
import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import RadioSelection from '../RadioSelection/RadioSelection';
import InputType from '../InputType/InputType';
import SearchResultTable from '../SearchResult/SearchResultTable';

import './Home.scss';
import Loader from '../Loader/Loader';

function Home({ rtl, dir }: AppProps) {
    const [currentValue, setCurrentValue] = useState('individuals');
    const [loading, setLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [tableData, setTableData] = useState([])
    const { t } = useTranslation();

    const handleSelectType = (e: any) => {
        setCurrentValue(e.target.value);
        setShowResult(false)
    }

    return (
        <>
            <Loader loading={loading} />
            <section className='Home'>
                <Typography rtl={rtl} className='title'>{t('Dividend_title')}</Typography>
                <Typography rtl={rtl} className='sub-title'>{t('Dividend_subtitle')}</Typography>
                <RadioSelection
                    rtl={rtl}
                    dir={dir}
                    radioValue={currentValue}
                    handleSelectType={handleSelectType}
                />

                <InputType
                    rtl={rtl}
                    dir={dir}
                    radioValue={currentValue}
                    setLoading={setLoading}
                    setShowResult={setShowResult}
                    setTableData={setTableData}
                />

                <Typography rtl={rtl} className='description'>{t('Service_Description')}</Typography>
            </section>
            {showResult && <SearchResultTable rtl={rtl} dir={dir} tableData={tableData} />}
        </>
    )
}

export default Home